export default "__VITE_PUBLIC_ASSET__a62c36bd__"